export const filter = [
  { name: "Filter by brand name", id: 1 },
  { name: "Filter by brand review", id: 2 },
  { name: "Filter by brand price", id: 3 },
  { name: "Filter by brand sale", id: 4 },
  { name: "Filter by brand fashion", id: 5 },
];

export const data = [
  { name: "Category Name", number: 320, id: 1 },
  { name: "Category Name", number: 112, id: 2 },
  { name: "Category Name", number: 32, id: 3 },
  { name: "Category Name", number: 48, id: 4 },
];
